import React, { useEffect, useState, useRef, useCallback } from "react";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "../../style.scss";
import { useAppContext } from "../../../../../AppContext";
import SearchDropdown from "../../../../search/seatchDropdown";
function EditUser() {
  const { uid } = useParams();
  const navigate = useNavigate();
  const { user, chimeraserv, components } = useAppContext();
  const props = { user, chimeraserv, components };
  const [reset, setReset] = useState(new Date().getTime());
  const [title] = useState("Create User | Chimera Solutions | Insights");
  const [form, setForm] = useState({ state: null, message: "" });
  const [data, setData] = useState(null);
  const [field, setField] = useState({
    username: { value: "", message: "", state: null },
    password: { value: "", state: null, message: "" },
    rePassword: { value: "", message: "", state: null },
    email: { value: "", message: "", state: null },
    type: {
      value: "",
      data: [
        { value: "admin", name: "Admin" },
        { value: "user", name: "User" },
        { value: "demo", name: "Demo" },
      ],
      message: "",
      state: null,
    },
    group: { value: "", data: [], message: "", state: null },

    level: { value: "", data: [], message: "", state: null },
  });
  const [load, setLoad] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const timeRef = useRef(null);

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // Helper for checker
  const checker = (state) => {
    const check = { icon: "check-circle", style: "null" };
    switch (state) {
      case true:
        check.icon = "check-circle";
        check.style = "correct";
        break;
      case false:
        check.icon = "times-circle";
        check.style = "wrong";
        break;
      default:
        break;
    }
    return check;
  };

  // Validate fields
  const validateFields = useCallback(() => {
    setForm((prev) => ({ ...prev, state: false }));
    if (
      field.username.state &&
      field.password.state &&
      field.rePassword.state &&
      field.email.state &&
      field.group.state &&
      field.level.state &&
      field.type.state
    ) {
      setForm((prev) => ({ ...prev, state: true }));
    }
  }, [field]);

  // Handle input change
  const checkField = (data, fields = field) => {
    clearTimeout(timeRef.current);
    timeRef.current = setTimeout(async () => {
      let updatedFields = { ...fields };
      switch (data.id) {
        case "username":
          if (data.value.length) {
            let state = true;
            let message = "";
            if (data.value.length <= 3) {
              state = false;
              message = "username should be minimum of 4 characters";
            }
            try {
              const response = await axios.get(chimeraserv.urlGet + "/user", {
                headers,
              });
              if (
                response.data.find((result) => result.username === data.value)
              ) {
                state = false;
                message = "username already exist";
              }
            } catch {}
            updatedFields.username = {
              ...updatedFields.username,
              state,
              message,
            };
            setField((prev) => ({ ...prev, username: updatedFields.username }));
          }
          break;
        case "password":
          if (data.value.length) {
            let state = true;
            let message = "";
            if (data.value.length <= 4) {
              state = false;
              message = "password should be minimum of 8 characters";
            }
            updatedFields.password = {
              ...updatedFields.password,
              state,
              message,
            };
            updatedFields.rePassword = {
              ...updatedFields.rePassword,
              state: null,
              message: "",
            };
            setField((prev) => ({
              ...prev,
              password: updatedFields.password,
              //rePassword: updatedFields.rePassword,
            }));
          }
          break;
        case "rePassword":
          if (data.value.length) {
            let state = true;
            let message = "";
            if (fields.password.value !== data.value) {
              state = false;
              message = "passwords did not match";
            }
            updatedFields.rePassword = {
              ...updatedFields.rePassword,
              state,
              message,
            };
            setField((prev) => ({
              ...prev,
              rePassword: updatedFields.rePassword,
            }));
          }
          break;

        case "email":
          if (data.value.length) {
            let state = true;
            let message = "";

            // First do the regex validation (no API call needed)
            const regex =
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!regex.test(String(data.value).toLowerCase())) {
              state = false;
              message = "invalid email address";
            } else {
              // Only check for existing email if the format is valid
              try {
                const response = await axios.get(chimeraserv.urlGet + "/user", {
                  headers,
                });
                if (
                  response.data.find((result) => result.email === data.value)
                ) {
                  state = false;
                  message = "email address already exist";
                }
              } catch {}
            }

            updatedFields.email = {
              ...updatedFields.email,
              state,
              message,
            };

            setField((prev) => ({
              ...prev,
              email: updatedFields.email,
            }));
          }
          break;
        case "type":
          if (data.value !== "0") {
            if (data.value === "admin") {
              updatedFields.type = {
                ...updatedFields.type,
                value: data.value,
                state: true,
              };
              updatedFields.group = {
                ...updatedFields.group,
                value: "",
                state: true,
              };
              updatedFields.level = {
                ...updatedFields.level,
                value: "0",
                state: true,
              };
            } else {
              updatedFields.type = {
                ...updatedFields.type,
                value: data.value,
                state: true,
              };
              // Reset group and level for non-admin users
              updatedFields.group = {
                ...updatedFields.group,
                value: "",
                state: null,
              };
              updatedFields.level = {
                ...updatedFields.level,
                value: "",
                data: [],
                state: null,
              };
            }
          } else {
            // Only reset if user selects "-- type of user --"
            updatedFields.type = {
              ...updatedFields.type,
              value: "",
              state: null,
            };
            updatedFields.group = {
              ...updatedFields.group,
              value: "",
              state: null,
            };
            updatedFields.level = {
              ...updatedFields.level,
              value: "",
              data: [],
              state: null,
            };
          }

          setField((prev) => ({
            ...prev,
            type: updatedFields.type,
            group: updatedFields.group,
            level: updatedFields.level,
          }));
          break;

        case "group":
          let group = {};
          try {
            group = JSON.parse(data.value);
          } catch {
            group = {};
          }

          if (data.value !== "0") {
            // Find the selected group from the data
            const foundGroup = updatedFields.group.data.find(
              (res) => res.grpKey === group.grpKey
            );

            // Set selectedGroup
            setSelectedGroup(foundGroup);

            updatedFields.group = {
              ...updatedFields.group,
              value: data.value, // Store the JSON string
              state: true,
            };

            updatedFields.level = {
              ...updatedFields.level,
              value: "",
              data: foundGroup?.levels || [],
              state: null,
            };
          } else {
            setSelectedGroup(null);
            updatedFields.group = {
              ...updatedFields.group,
              value: "",
              state: null,
            };

            updatedFields.level = {
              ...updatedFields.level,
              value: "",
              data: [],
              state: null,
            };
          }

          setField((prev) => ({
            ...prev,
            group: updatedFields.group,

            level: updatedFields.level,
          }));
          break;

        case "level":
          if (data.value !== "0") {
            updatedFields.level = {
              ...updatedFields.level,
              value: data.value,
              state: true,
            };
          } else {
            updatedFields.level = {
              ...updatedFields.level,
              value: "",
              state: null,
            };
          }

          setField((prev) => ({
            ...prev,
            level: updatedFields.level,
          }));
          break;

        default:
          break;
      }
      const delay = data.id === "email" ? 2000 : 500;
      //setTimeout(() => validateFields({ ...field, ...updatedFields }), 100);
      timeRef.current = setTimeout(() => {
        setField((updatedFields) => {
          validateFields(updatedFields);
          return updatedFields;
        });
      }, delay);
    }, 1000);
  };
  const valueChanged = (event) => {
    const element = event.target;
    setField((prev) => ({
      ...prev,
      [element.id]: {
        ...prev[element.id],
        value: element.value,
        message: "",
        state: null,
      },
    }));
    setForm((prev) => ({ ...prev, state: false }));
    // checkField(element);
    // Only validate select fields immediately
    // const selectFields = ["type", "group", "level"];
    // if (selectFields.includes(element.id)) {
    //   checkField(element);
    // }
    checkField(element, {
      ...field,
      [element.id]: {
        ...field[element.id],
        value: element.value,
      },
    });
  };

  // Get group data
  const getGroup = useCallback(async () => {
    try {
      const response = await axios.get(props.chimeraserv.urlGet + "/group", {
        headers,
      });
      setField((prev) => ({
        ...prev,
        group: {
          ...prev.group,
          data: response.data,
        },
      }));
    } catch {}
  }, [props.chimeraserv.urlGet, headers]);

  const loadData = useCallback(async () => {
    try {
      const response = await axios.get(
        props.chimeraserv.urlGet + "/user/" + uid,
        { headers }
      );
      if (response.data && response.data.length) {
        const userData = response.data[0];
        setData(userData);
        setLoad(true);

        // Find the group data to create the proper JSON string
        const groupData = field.group.data.find(
          (g) => g._id === userData.group
        );

        if (groupData) {
          setSelectedGroup(groupData);

          setField((prev) => ({
            ...prev,
            username: {
              ...prev.username,
              value: userData.username,
              state: true,
            },
            email: { ...prev.email, value: userData.email, state: true },
            password: { ...prev.password, value: "", state: null },
            rePassword: { ...prev.rePassword, value: "", state: null },
            type: { ...prev.type, value: userData.type, state: true },
            group: {
              ...prev.group,
              value: JSON.stringify({
                name: groupData.name,
                grpKey: groupData.grpKey,
                _id: groupData._id,
              }),
              state: true,
            },

            level: {
              ...prev.level,
              value: userData.level,
              data: groupData.levels || [],
              state: true,
            },
          }));
        } else {
          // Fallback if group not found
          setField((prev) => ({
            ...prev,
            username: {
              ...prev.username,
              value: userData.username,
              state: true,
            },
            email: { ...prev.email, value: userData.email, state: true },
            password: { ...prev.password, value: "", state: null },
            rePassword: { ...prev.rePassword, value: "", state: null },
            type: { ...prev.type, value: userData.type, state: true },
            group: { ...prev.group, value: userData.group, state: true },

            level: { ...prev.level, value: userData.level, state: true },
          }));
        }
      }
    } catch {}
  }, [props.chimeraserv.urlGet, uid, headers, field.group.data]);
  // Reset handler
  const resetHandler = () => {
    setReset(new Date().getTime());
  };

  // Generate password
  const genPass = () => {
    const length = 8;
    const charset = `!@#$%^&*()-=abcdefghijklmnopqrstuvwxyz0123456789`;
    const retVal = [];
    for (let i = 0, n = charset.length; i < length; ++i) {
      let char = charset.charAt(Math.floor(Math.random() * n));
      if (Math.round(Math.random())) {
        retVal.push(char.toUpperCase());
      } else {
        retVal.push(char.toLowerCase());
      }
    }
    const password = String(retVal.join(""));
    setField((prev) => ({
      ...prev,
      password: {
        ...prev.password,
        message: `Generated new password: ${password}`,
        value: password,
        state: true,
      },
      rePassword: {
        ...prev.rePassword,
        value: password,
        state: true,
      },
    }));
    validateFields();
  };

  const submit = async () => {
    setForm((prev) => ({ ...prev, state: false, message: "" }));
    try {
      // Parse group data if it's a JSON string
      let groupValue = field.group.value;
      if (typeof groupValue === "string" && groupValue !== "0") {
        try {
          const groupData = JSON.parse(groupValue);
          groupValue = groupData._id; // Send the group ID to the server
        } catch (e) {
          console.error("Error parsing group value:", e);
        }
      }

      const response = await axios.put(
        props.chimeraserv.urlPost + "/user/update",
        {
          ...data,
          username: field.username.value,
          password: field.password.value,
          email: field.email.value,
          group: groupValue,

          type: field.type.value,
          level: field.level.value,
        },
        {
          headers: {
            Authorization: props.user.data.usrKey,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data && !response.data.__v) {
        resetHandler();
        setForm((prev) => ({ ...prev, message: "User Updated" }));
      }
    } catch (error) {
      setForm((prev) => ({
        ...prev,
        message: JSON.stringify(error),
      }));
    }
  };

  // Effect for initial load and reset
  useEffect(() => {
    if (props.user.data.type !== "admin") {
      setField((prev) => ({
        ...prev,
        type: { ...prev.type, value: "user", state: true },
      }));
    }
    getGroup();
    loadData();
    // eslint-disable-next-line
  }, [reset]);

  // Add blur handler
  const handleBlur = (event) => {
    const apiFields = ["username", "email", "password", "rePassword"];
    if (apiFields.includes(event.target.id)) {
      checkField(event.target);
    }
  };

  // Loader
  const Loader =
    props.components && props.components.setting && props.components.setting[1]
      ? props.components.setting[1].component
      : () => <div>Loading...</div>;

  return (
    <div className={"custForm"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={["viewTitle"]}>Edit User</div>
      {!load ? (
        <Loader />
      ) : (
        <form className={"form"}>
          <div className={["form-group"]}>
            <label htmlFor="username">
              Username <span>*</span>
            </label>
            <FontAwesomeIcon
              className={["icon", checker(field.username.state).style].join(
                " "
              )}
              icon={["fas", checker(field.username.state).icon]}
            />
            <div className={["field"]}>
              <input
                type="text"
                className="form-control"
                id="username"
                placeholder="username"
                value={field.username.value}
                onChange={valueChanged}
                onBlur={handleBlur}
              />
              <span>{field.username.message}</span>
            </div>
          </div>
          <div className={["form-group"]}>
            <label htmlFor="password">
              Password <span>*</span>
            </label>
            <FontAwesomeIcon
              className={["icon", checker(field.password.state).style].join(
                " "
              )}
              icon={["fas", checker(field.password.state).icon]}
            />
            <div className={["field"]}>
              <div className={["password"]}>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="password"
                  value={field.password.value}
                  onChange={valueChanged}
                  onBlur={handleBlur}
                />
                <button type="button" onClick={genPass}>
                  <FontAwesomeIcon className="icon" icon="sync-alt" />
                </button>
              </div>
              <span>{field.password.message}</span>
            </div>
          </div>
          <div className={["form-group"]}>
            <label htmlFor="rePassword">
              Re-type Password <span>*</span>
            </label>
            <FontAwesomeIcon
              className={["icon", checker(field.rePassword.state).style].join(
                " "
              )}
              icon={["fas", checker(field.rePassword.state).icon]}
            />
            <div className={["field"]}>
              <input
                type="password"
                className="form-control"
                id="rePassword"
                placeholder="re-type password"
                value={field.rePassword.value}
                onChange={valueChanged}
                onBlur={handleBlur}
              />
              <span>{field.rePassword.message}</span>
            </div>
          </div>
          <div className={["form-group"]}>
            <label htmlFor="email">
              Email Address <span>*</span>
            </label>
            <FontAwesomeIcon
              className={["icon", checker(field.email.state).style].join(" ")}
              icon={["fas", checker(field.email.state).icon]}
            />
            <div className={["field"]}>
              <input
                type="text"
                className="form-control"
                id="email"
                placeholder="email address"
                value={field.email.value}
                onChange={valueChanged}
              />
              <span>{field.email.message}</span>
            </div>
          </div>
          {props.user.data.type === "admin" ? (
            <div>
              <div className={["form-group"]}>
                <label htmlFor="type">
                  Type <span>*</span>
                </label>
                <FontAwesomeIcon
                  className={["icon", checker(field.type.state).style].join(
                    " "
                  )}
                  icon={["fas", checker(field.type.state).icon]}
                />
                <select
                  className="form-control"
                  id="type"
                  onChange={valueChanged}
                  value={field.type.value}
                >
                  <option value={0}>-- type of user --</option>
                  {field.type.data.map((data, key) => (
                    <option value={data.value} key={key}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              {field.type.state ? (
                field.type.value !== "admin" ? (
                  <div>
                    <div className={["form-group"]}>
                      <label htmlFor="group">
                        Group <span>*</span>
                      </label>
                      <FontAwesomeIcon
                        className={[
                          "icon",
                          checker(field.group.state).style,
                        ].join(" ")}
                        icon={["fas", checker(field.group.state).icon]}
                      />

                      <SearchDropdown
                        data={field.group.data}
                        name="group"
                        value={field.group.data.name}
                        searchFields={["name", "grpKey"]}
                        displayField="name"
                        placeholder="Search business group..."
                        required={true}
                        showIcon={false}
                        state={!!field.group.state}
                        onSelect={(group) => {
                          // Simulate a change event for valueChanged
                          const fakeEvent = {
                            target: {
                              id: "group",
                              value: JSON.stringify({
                                name: group.name,
                                grpKey: group.grpKey,
                                _id: group._id,
                              }),
                              getAttribute: (attr) => {
                                if (attr === "data-field") return null;
                                if (attr === "data-key") return null;
                                return undefined;
                              },
                            },
                          };
                          valueChanged(fakeEvent);
                        }}
                        allowClear={true}
                        noResultsText="No groups found"
                      />

                      {/* <select
                        className="form-control"
                        id="group"
                        onChange={valueChanged}
                        value={
                          field.group.value &&
                          field.group.value !== "" &&
                          field.group.value !== "0"
                            ? field.group.value
                            : "0"
                        }
                        // value={field.group.value}
                      >
                        <option value={0}>-- business group of user --</option>
                        {field.group.data.map((data, key) => (
                          <option
                            value={JSON.stringify({
                              name: data.name,
                              grpKey: data.grpKey,
                              _id: data._id,
                            })}
                            key={key}
                          >
                            {data.name}
                          </option>
                        ))}
                      </select> */}
                    </div>
                    <div className={["form-group"]}>
                      <label htmlFor="level">
                        User level <span>*</span>
                      </label>
                      <FontAwesomeIcon
                        className={[
                          "icon",
                          checker(field.level.state).style,
                        ].join(" ")}
                        icon={["fas", checker(field.level.state).icon]}
                      />
                      <select
                        className="form-control"
                        id="level"
                        onChange={valueChanged}
                        value={field.level.value}
                      >
                        <option value={0}>-- level of user --</option>
                        {field.level.data.map((data, key) => (
                          <option value={data.id} key={key}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  <div />
                )
              ) : (
                <div />
              )}
            </div>
          ) : (
            <div>
              <div className={["form-group"]}>
                <label htmlFor="group">
                  Group <span>*</span>
                </label>
                <FontAwesomeIcon
                  className={["icon", checker(field.group.state).style].join(
                    " "
                  )}
                  icon={["fas", checker(field.group.state).icon]}
                />
                <select
                  className="form-control"
                  id="group"
                  onChange={valueChanged}
                  value={field.group.value}
                >
                  <option value={0}>-- business group of user --</option>
                  {field.group.data.map((data, key) => (
                    <option
                      value={JSON.stringify({
                        name: data.name,
                        grpKey: data.grpKey,
                        _id: data._id,
                      })}
                      key={key}
                    >
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={["form-group"]}>
                <label htmlFor="brand">
                  Brand <span>*</span>
                </label>
                <FontAwesomeIcon
                  className={["icon", checker(field.brand.state).style].join(
                    " "
                  )}
                  icon={["fas", checker(field.brand.state).icon]}
                />
                <select
                  className="form-control"
                  id="brand"
                  onChange={valueChanged}
                  value={field.brand.value}
                >
                  <option value={0}>-- business brand of user --</option>
                  {field.brand.data.map((data, key) => (
                    <option
                      value={JSON.stringify({
                        name: data.name,
                        braKey: data.braKey,
                        _id: data._id,
                      })}
                      key={key}
                    >
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={["form-group"]}>
                <label htmlFor="level">
                  User level <span>*</span>
                </label>
                <FontAwesomeIcon
                  className={["icon", checker(field.level.state).style].join(
                    " "
                  )}
                  icon={["fas", checker(field.level.state).icon]}
                />
                <select
                  className="form-control"
                  id="level"
                  onChange={valueChanged}
                  value={field.level.value}
                >
                  <option value={0}>-- level of user --</option>
                  {field.level.data.map((data, key) => (
                    <option value={data.id} key={key}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {form.message ? (
            <div className={["message", "form-group"].join(" ")}>
              <FontAwesomeIcon
                className={["icon", "correct"].join(" ")}
                icon={"check-circle"}
              />
              {form.message}
            </div>
          ) : (
            <div />
          )}
          <button
            type="button"
            className={["btn btn-primary"]}
            disabled={!form.state}
            onClick={submit}
          >
            Update
          </button>
          <button
            type="button"
            onClick={resetHandler}
            className={["btn btn-primary", "reset"].join(" ")}
          >
            Reset
          </button>
        </form>
      )}
    </div>
  );
}

export default EditUser;
